import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  hrmsDesignationSearch: {
    cursor: "pointer",
    margin: "5px 0px",
  },
}));

const DesignationSearch = ({ highlightText, item }) => {
  const navigate = useNavigate();

  const classes = useStyle();

  const handleRedirect = () => {
    navigate("/designations");
  };
  return (
    <Grid onClick={handleRedirect} className={classes.hrmsDesignationSearch}>
      <Typography>{highlightText(item.designation_name)}</Typography>
    </Grid>
  );
};

export default DesignationSearch;
